/**
 * Envio por WhatsApp. O backend (`whatsapp/enviar`) resolve o telefone no cadastro, monta o texto com o modelo da empresa e
 * registra o envio; aqui só se abre o WhatsApp com a mensagem pronta. Quando houver um provedor de API, o backend passa a
 * disparar sozinho e esta função deixa de abrir a janela, sem mudar as telas.
 *
 * Uso nas telas: this.$whatsapp.enviar({ tipo: 'ORCAMENTO', entidadeId: 12 })
 *   tipos: ORCAMENTO, COBRANCA (entidadeId = título), COBRANCA_LOTE (ids = títulos), PEDIDO, ORDEM_SERVICO, RELATORIO (dados)
 */
import Swal from 'sweetalert2'

function mensagemDoErro(error, padrao) {
	return error?.response?.data?.message || padrao
}

// Quando o cadastro não tem celular: pergunta o número, valida no servidor e oferece salvá-lo no cadastro.
async function pedirTelefone(vm, resposta, headers) {
	const salvarHtml = resposta.pessoaNome
		? '<label class="d-flex align-items-center gap-2 justify-content-center mt-2" style="font-size:13px"><input id="wa-salvar-cadastro" type="checkbox" checked> Salvar no cadastro de ' + String(resposta.pessoaNome).replace(/</g, '&lt;') + '</label>'
		: ''
	const { isConfirmed, value } = await Swal.fire({
		icon: 'question',
		title: 'Para qual número enviar?',
		html: '<div class="text-muted" style="font-size:14px">' + String(resposta.aviso || 'Nenhum celular encontrado no cadastro.').replace(/</g, '&lt;') + '</div>' + salvarHtml,
		input: 'text',
		inputPlaceholder: '(DDD) 9 0000-0000',
		inputAttributes: { inputmode: 'tel', autocomplete: 'off' },
		showCancelButton: true,
		confirmButtonText: 'Continuar',
		cancelButtonText: 'Cancelar',
		preConfirm: async (telefone) => {
			try {
				const r = await vm.$axios.get(vm.$store.state.urlRest + 'whatsapp/normalizar', { headers, params: { telefone } })
				if (!r.data.valido) { Swal.showValidationMessage(r.data.aviso || 'Telefone inválido.'); return false }
				const caixa = document.getElementById('wa-salvar-cadastro')
				return { telefone, salvar: caixa ? caixa.checked : false }
			} catch (e) {
				Swal.showValidationMessage('Não foi possível validar o telefone.')
				return false
			}
		}
	})
	return isConfirmed ? value : null
}

// Sempre uma aba nova (nunca reaproveita a aba do ERP nem uma aba do WhatsApp já aberta) e sem ligação com o ERP.
// Se o navegador bloquear o pop-up, tenta por um link com target=_blank; devolve false se nada abriu.
function abrirEmNovaAba(url) {
	const janela = window.open(url, '_blank')
	if (janela) {
		try { janela.opener = null } catch (e) { /* janela de outra origem */ }
		return true
	}
	try {
		const link = document.createElement('a')
		link.href = url
		link.target = '_blank'
		link.rel = 'noopener noreferrer'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		return true
	} catch (e) {
		return false
	}
}

export async function enviarWhatsApp(vm, opcoes = {}) {
	const headers = { 'X-Company-Id': vm.$store.state.empresa?.id }
	const url = vm.$store.state.urlRest + 'whatsapp/enviar'
	const base = { ...opcoes, baseUrl: window.location.origin }
	const chamar = corpo => vm.$axios.post(url, corpo, { headers }).then(res => res.data)
	try {
		let resposta = await chamar(base)
		if (resposta.pendenteTelefone) {
			const tel = await pedirTelefone(vm, resposta, headers)
			if (!tel) return null
			resposta = await chamar({ ...base, telefone: tel.telefone, salvarTelefoneNoCadastro: tel.salvar })
		}
		if (resposta.aviso) vm.$toast.fire({ icon: 'info', title: resposta.aviso })
		const janela = abrirEmNovaAba(resposta.url)
		if (!janela) {
			// pop-up bloqueado: deixa a mensagem pronta para colar
			try { await navigator.clipboard.writeText(resposta.texto) } catch (e) { /* sem acesso à área de transferência */ }
			Swal.fire({ icon: 'warning', title: 'O navegador bloqueou a abertura do WhatsApp', text: 'Permita pop-ups para este site. A mensagem foi copiada para a área de transferência.' })
		}
		return resposta
	} catch (error) {
		vm.$toast.fire({ icon: 'error', title: mensagemDoErro(error, 'Não foi possível preparar a mensagem de WhatsApp.') })
		return null
	}
}

export default {
	install(Vue) {
		// getter por componente: dá ao helper acesso ao axios, ao store e ao toast do componente que chamou
		Object.defineProperty(Vue.prototype, '$whatsapp', {
			get() {
				const vm = this
				return { enviar: opcoes => enviarWhatsApp(vm, opcoes) }
			}
		})
	}
}
